import { safeRenderPropComponent } from '@/utils'
import { AuthGuard } from './AuthGuard'
import { ComponentType, JSX } from 'react'

interface Props {
  element: JSX.Element
}

export const ProtectedRoute = ({ element }: Props) => {
  const Element = AuthGuard(safeRenderPropComponent(element) as ComponentType)

  return <Element />
}
